import { render } from "./PermissionManageView.vue?vue&type=template&id=0a9b08f2&scoped=true"
import script from "./PermissionManageView.vue?vue&type=script&lang=js"
export * from "./PermissionManageView.vue?vue&type=script&lang=js"

import "./PermissionManageView.vue?vue&type=style&index=0&id=0a9b08f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9b08f2"]])

export default __exports__